<template>
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M80 140C113.137 140 140 113.137 140 80C140 46.8629 113.137 20 80 20C46.8629 20 20 46.8629 20 80C20 113.137 46.8629 140 80 140Z"
      fill="url(#paint0_linear_10083_74108)"
    />
    <path
      d="M112.272 43.7791H37.8794L36.6201 45.8778V50.3984L70.7586 109.528L130.364 75.115L112.272 43.7791Z"
      fill="#D5DDEA"
    />
    <g filter="url(#filter0_d_10083_74108)">
      <path
        d="M134.663 41.2335V111.279C134.663 113.6 132.752 115.512 130.432 115.512H40.1801C37.8602 115.512 35.9497 113.6 35.9497 111.279V41.2335C35.9497 38.9119 37.8602 37 40.1801 37H130.432C132.752 37 134.663 38.9119 134.663 41.2335Z"
        fill="url(#paint1_linear_10083_74108)"
      />
    </g>
    <path
      opacity="0.24"
      d="M113.115 45.2403C112.592 44.333 111.632 43.7647 110.585 43.741L39.5365 42.1375C38.512 42.1144 37.5538 42.6427 37.0266 43.5214C36.7606 43.9647 36.6201 44.4719 36.6201 44.9888V49.5945C36.6201 50.1212 36.7587 50.6385 37.022 51.0945L69.2586 106.93C70.0871 108.365 71.9218 108.856 73.3567 108.028L127.766 76.6151C129.2 75.7866 129.692 73.9519 128.864 72.517L113.115 45.2403Z"
      fill="url(#paint2_linear_10083_74108)"
    />
    <path
      d="M134.663 41.2335V44.3061H35.9497V41.2335C35.9497 38.9119 37.8602 37 40.1801 37H130.432C132.752 37 134.663 38.9119 134.663 41.2335Z"
      fill="#67AEFF"
    />
    <path
      d="M40.3863 41.9846C41.1023 41.9846 41.6827 41.4038 41.6827 40.6872C41.6827 39.9707 41.1023 39.3899 40.3863 39.3899C39.6703 39.3899 39.0898 39.9707 39.0898 40.6872C39.0898 41.4038 39.6703 41.9846 40.3863 41.9846Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.6"
      d="M44.4112 41.9846C45.1272 41.9846 45.7076 41.4038 45.7076 40.6872C45.7076 39.9707 45.1272 39.3899 44.4112 39.3899C43.6952 39.3899 43.1147 39.9707 43.1147 40.6872C43.1147 41.4038 43.6952 41.9846 44.4112 41.9846Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.4"
      d="M48.5049 41.9846C49.2209 41.9846 49.8013 41.4038 49.8013 40.6872C49.8013 39.9707 49.2209 39.3899 48.5049 39.3899C47.7889 39.3899 47.2085 39.9707 47.2085 40.6872C47.2085 41.4038 47.7889 41.9846 48.5049 41.9846Z"
      fill="#EAEEF9"
    />
    <path
      d="M126.56 82.2702L126.228 82.2488C126.144 82.2264 126.114 82.1731 126.136 82.0892C126.159 82.0052 126.212 81.9744 126.307 81.9549L126.639 81.9763C126.707 81.9722 126.753 82.052 126.757 82.1206C126.708 82.2199 126.628 82.2661 126.56 82.2702Z"
      fill="#D5DDEA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M119.801 69.4523C119.292 68.5705 119.594 67.443 120.475 66.934L125.527 64.015C128.464 62.3181 132.22 63.3251 133.916 66.2643L141.745 79.8351C143.441 82.7743 142.435 86.5326 139.497 88.2295L111.711 104.284C110.536 104.963 110.133 106.466 110.812 107.642L112.562 110.675C113.07 111.557 112.768 112.684 111.887 113.193C111.006 113.702 109.88 113.4 109.371 112.519L107.621 109.485C105.925 106.546 106.931 102.788 109.868 101.091L137.655 85.0364C138.83 84.3576 139.233 82.8543 138.554 81.6786L130.725 68.1078C130.047 66.9322 128.544 66.5293 127.369 67.2081L122.317 70.1271C121.436 70.6362 120.309 70.334 119.801 69.4523Z"
      fill="#93C0F1"
    />
    <path
      d="M128.436 136.592L123.809 139.265C122.665 139.926 121.197 139.532 120.537 138.388L107.749 116.223C107.089 115.078 107.482 113.609 108.626 112.949L113.252 110.276C114.396 109.615 115.864 110.009 116.524 111.153L129.312 133.318C129.972 134.463 129.579 135.932 128.436 136.592Z"
      fill="#67AEFF"
    />
    <g filter="url(#filter1_d_10083_74108)">
      <path
        d="M120.965 60.4071L128.211 72.9667C129.792 75.7075 128.848 79.2331 126.109 80.8155L76.7311 109.344C73.9923 110.927 70.4691 109.982 68.8879 107.241L61.6418 94.6818C60.0606 91.941 61.0046 88.4153 63.7434 86.8329L113.121 58.304C115.86 56.7216 119.383 57.6663 120.965 60.4071Z"
        fill="url(#paint3_linear_10083_74108)"
      />
    </g>
    <path
      d="M78.8329 64.2173L79.8438 63.7677C80.1808 63.6553 80.1808 63.2056 79.8438 63.0932L78.8329 62.6436C77.5973 62.0816 76.5864 61.0699 76.0248 59.8334L75.5754 58.8218C75.4631 58.4845 75.0138 58.4845 74.9015 58.8218L74.4522 59.8334C73.8906 61.0699 72.8796 62.0816 71.644 62.6436L70.6331 63.0932C70.2961 63.2056 70.2961 63.6553 70.6331 63.7677L71.644 64.2173C72.8796 64.7793 73.8906 65.791 74.4522 67.0275L74.9015 68.0391C75.0138 68.3763 75.4631 68.3763 75.5754 68.0391L76.0248 67.0275C76.4741 65.791 77.485 64.7793 78.8329 64.2173Z"
      fill="white"
    />
    <path
      d="M67.9383 57.8098L68.6123 57.4726C68.7297 57.4138 68.7858 57.3243 68.7804 57.2362C68.7689 57.0472 68.5221 56.9929 68.3425 56.933L67.9383 56.7982C67.0397 56.4609 66.3658 55.7865 66.0288 54.8872L65.6918 54.2128C65.633 54.0952 65.5435 54.0391 65.4554 54.0446C65.2666 54.0563 65.2125 54.3029 65.1527 54.4824L65.1077 54.6177C65.0479 54.7972 64.9778 54.9736 64.8837 55.1376C64.4393 55.9117 63.8198 56.493 63.1083 56.7982L62.498 57.0599C62.3819 57.1097 62.2441 57.1602 62.2382 57.2864C62.2314 57.431 62.3894 57.5063 62.5189 57.5711L62.996 57.8098C63.8946 58.147 64.5686 58.8215 65.0179 59.7207L65.3548 60.3952C65.4136 60.5128 65.5032 60.5689 65.5913 60.5634C65.7801 60.5517 65.8341 60.3051 65.8939 60.1256L66.0288 59.7207C66.3658 58.8215 67.0397 58.147 67.9383 57.8098Z"
      fill="white"
    />
    <path
      d="M76.5862 51.2905L76.9683 51.1376C77.0868 51.0901 77.2321 51.0247 77.2321 50.897C77.2321 50.7694 77.0868 50.704 76.9683 50.6565L76.5862 50.5036C75.9123 50.2788 75.463 49.7168 75.126 49.0423L74.9731 48.6599C74.9258 48.5414 74.8605 48.396 74.7329 48.396C74.6053 48.396 74.54 48.5414 74.4926 48.6599L74.3397 49.0423C74.1151 49.7168 73.5534 50.1664 72.8795 50.5036L72.5425 50.7284C72.2356 50.882 72.7062 51.1312 73.0249 51.2587L73.1041 51.2905C73.7781 51.5153 74.2274 52.0773 74.5644 52.7518L74.7172 53.1342C74.7646 53.2527 74.8299 53.3981 74.9575 53.3981C75.0851 53.3981 75.1504 53.2527 75.1978 53.1342L75.2732 52.9456C75.3247 52.8167 75.3579 52.6814 75.3987 52.5487C75.5778 51.966 76.082 51.4923 76.5862 51.2905Z"
      fill="white"
    />
    <path
      opacity="0.14"
      d="M43.1551 58.5861L55.4872 62.0255C57.199 62.5088 58.1929 64.275 57.7144 66.004L48.18 100.881C46.7627 106.049 41.4801 109.08 36.3632 107.648C31.2463 106.217 28.2461 100.881 29.6634 95.7126L39.2162 60.8542C39.6948 59.1252 41.4433 58.1213 43.1551 58.5861ZM37.0627 105.157C39.6027 105.863 42.2164 104.357 42.9158 101.792C43.6153 99.2263 42.1244 96.5863 39.5843 95.8799C37.0443 95.1734 34.4306 96.6793 33.7312 99.2449C33.0501 101.81 34.5226 104.45 37.0627 105.157Z"
      fill="url(#paint4_linear_10083_74108)"
    />
    <path
      d="M40.4154 56.7602L52.7475 60.1995C54.4592 60.6829 55.4532 62.4491 54.9746 64.178L45.4402 99.055C44.023 104.223 38.7404 107.254 33.6235 105.822C28.5066 104.391 25.5064 99.055 26.9237 93.8866L36.4764 59.0283C36.955 57.2993 38.7036 56.2954 40.4154 56.7602ZM34.3229 103.331C36.863 104.037 39.4766 102.531 40.1761 99.9659C40.8755 97.4003 39.3846 94.7604 36.8446 94.0539C34.3045 93.3475 31.6908 94.8534 30.9914 97.4189C30.3104 99.9845 31.7829 102.624 34.3229 103.331Z"
      fill="#7BB7FD"
    />
    <path
      d="M29.6511 58.3364H41.9548C43.6519 58.3364 45.0308 59.7486 45.0308 61.4867V96.7368C45.0308 101.951 40.8942 106.188 35.803 106.188C30.7118 106.188 26.5752 101.969 26.5752 96.7368V61.4867C26.5752 59.7486 27.9541 58.3364 29.6511 58.3364ZM35.803 102.223C37.5531 102.223 38.985 100.756 38.985 98.9637C38.985 97.1713 37.5707 95.7048 35.803 95.7048C34.0529 95.7048 32.621 97.1532 32.621 98.9637C32.621 100.756 34.0352 102.223 35.803 102.223Z"
      fill="white"
    />
    <path
      d="M26.5752 81.0024H45.0308V91.9159H26.5752V81.0024Z"
      fill="#D6E4F8"
    />
    <path
      d="M26.5752 69.2495H45.0308V81.0024H26.5752V69.2495Z"
      fill="#B9D6FB"
    />
    <path
      opacity="0.7"
      d="M26.5752 61.4191V69.2498H45.0308V61.4191C45.0308 59.7183 43.6506 58.3364 41.9519 58.3364H29.6364C27.9554 58.3364 26.5752 59.7183 26.5752 61.4191Z"
      fill="#67AEFF"
    />
    <path
      d="M24.4575 57.0996L37.3562 71.7812C38.387 72.9545 38.5751 74.576 37.9641 75.887L39.5368 77.6771C40.0918 78.3089 40.0366 79.2642 39.4134 79.8126C38.7901 80.361 37.8362 80.2934 37.2812 79.6616L35.7085 77.8716C34.331 78.3101 32.7481 77.9159 31.7172 76.7425L18.8185 62.0609L24.4575 57.0996Z"
      fill="white"
      stroke="#989FB0"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M24.5233 68.0786C27.3699 69.0479 30.0902 68.882 32.5437 68.7324C33.4017 68.6801 34.227 68.6297 35.0136 68.6306L37.8114 71.8128C38.8429 72.9861 39.0311 74.6076 38.4197 75.9186L39.9935 77.7087C40.5489 78.3405 40.4937 79.2958 39.87 79.8442C39.2463 80.3925 38.2917 80.325 37.7363 79.6932L36.1624 77.9031C34.784 78.3417 33.1999 77.9474 32.1683 76.7741L24.5233 68.0786Z"
      fill="#BEDCFD"
    />
    <path
      d="M24.4575 57.0996L37.3562 71.7812C38.387 72.9545 38.5751 74.576 37.9641 75.887L39.5368 77.6771C40.0918 78.3089 40.0366 79.2642 39.4134 79.8126C38.7901 80.361 37.8362 80.2934 37.2812 79.6616L35.7085 77.8716C34.331 78.3101 32.7481 77.9159 31.7172 76.7425L18.8185 62.0609L24.4575 57.0996V57.0996Z"
      stroke="#8EBCF6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M18.8088 63.6315L24.5554 58.5756C25.3847 57.8459 25.4659 56.5818 24.7369 55.7519L20.4462 50.8682C18.6808 48.8587 15.631 48.6625 13.623 50.4292C11.6149 52.1959 11.4189 55.2479 13.1843 57.2574L18.7829 63.6299C18.7896 63.6375 18.8012 63.6382 18.8088 63.6315Z"
      fill="url(#paint5_linear_10083_74108)"
    />
    <path
      d="M19.242 64.5427L26.9165 57.7904C27.6317 57.1612 27.7015 56.0749 27.0727 55.3592C26.4439 54.6435 25.3584 54.5737 24.6432 55.2029L16.9687 61.9551C16.2535 62.5844 16.1837 63.6707 16.8125 64.3864C17.4155 65.1004 18.5131 65.184 19.242 64.5427Z"
      fill="url(#paint6_linear_10083_74108)"
    />
    <path
      d="M41.8004 87.4158C41.8004 89.0508 40.6317 90.3696 39.2046 90.3494C37.6835 90.3225 36.5441 88.7749 36.691 87.0457C36.8495 85.1887 38.1709 83.6546 38.8463 82.9817C39.0695 82.7597 39.4042 82.7597 39.6274 82.9817C40.3439 83.7017 41.8004 85.4107 41.8004 87.4158Z"
      stroke="#8EBCF6"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <defs>
      <filter
        id="filter0_d_10083_74108"
        x="13.9497"
        y="26"
        width="142.713"
        height="122.512"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74108"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74108"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74108"
        x="38.875"
        y="46.5366"
        width="112.103"
        height="96.5752"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74108"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74108"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74108"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74108"
        x1="85.274"
        y1="35.1839"
        x2="85.274"
        y2="116.359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74108"
        x1="36.6187"
        y1="109.528"
        x2="100.545"
        y2="20.6521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74108"
        x1="88.1127"
        y1="72.0589"
        x2="101.555"
        y2="95.3255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74108"
        x1="57.8349"
        y1="108.002"
        x2="14.996"
        y2="83.3333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_74108"
        x1="13.623"
        y1="50.4292"
        x2="22.4331"
        y2="60.4428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81B8FF" />
        <stop offset="1" stop-color="#006FFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_74108"
        x1="20.8058"
        y1="58.5791"
        x2="23.081"
        y2="61.165"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81B8FF" />
        <stop offset="1" stop-color="#006FFF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
